import { render, staticRenderFns } from "./SetPasswordForm.vue?vue&type=template&id=483f689a&"
import script from "./SetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./SetPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports